module.exports = __webpack_public_path__ + "static/media/district.312eaf79.png";